module.exports = __webpack_public_path__ + "static/media/use2.98be94a8.jpeg";